// La duración de un efecto de sonido (ElevenLabs, `eleven_text_to_sound_v2`): de 0,5 a
// 30 s, los mismos topes que `acotarDuracionDeEfecto` del backend
// (atlas-backend/src/providers/elevenLabsAudio.ts). En el Estudio siempre se pide una
// (es el largo del clip); sin dato, 5 s
// (ADR-2026-09-27-efectos-de-sonido-con-elevenlabs).

export const EFECTO_DURACION_MIN_SEG = 0.5;
export const EFECTO_DURACION_MAX_SEG = 30;
export const EFECTO_DURACION_DEFAULT_SEG = 5;

export function acotarDuracionDeEfecto(seg: unknown): number {
  const n = typeof seg === 'number' ? seg : Number(seg);
  if (!Number.isFinite(n) || n <= 0) return EFECTO_DURACION_DEFAULT_SEG;
  return Math.min(EFECTO_DURACION_MAX_SEG, Math.max(EFECTO_DURACION_MIN_SEG, Math.round(n * 2) / 2));
}
